"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createActivityStreamIntl = void 0;
var R = __importStar(require("../../utils/ramda"));
var createActivityStreamIntl = function (intl) {
  var _a;
  var formatMessage = (_a = intl === null || intl === void 0 ? void 0 : intl.formatMessage) !== null && _a !== void 0 ? _a : R.prop("defaultMessage");
  return {
    title: formatMessage({
      id: "VSX.ActivityStream.title",
      defaultMessage: "Activity Stream"
    }),
    closeButtonTooltip: formatMessage({
      id: "VSX.ActivityStream.closeButtonTooltip",
      defaultMessage: "Close activity stream"
    }),
    commentBoxTitle: formatMessage({
      id: "VSX.ActivityStream.commentBoxTitle",
      defaultMessage: "Comment"
    }),
    commentSendButton: formatMessage({
      id: "VSX.ActivityStream.commentSendButton",
      defaultMessage: "Add"
    }),
    commentPlaceholder: formatMessage({
      id: "VSX.ActivityStream.commentPlaceholder",
      defaultMessage: "Enter text"
    }),
    visibleToInternal: formatMessage({
      id: "VSX.ActivityStream.visibleToInternal",
      defaultMessage: "Visible to CJ only"
    }),
    visibleToAdvertisers: formatMessage({
      id: "VSX.ActivityStream.visibleToAdvertisers",
      defaultMessage: "Not visible to publisher"
    }),
    visibleToEveryone: formatMessage({
      id: "VSX.ActivityStream.visibleToEveryone",
      defaultMessage: "Visible to all users"
    }),
    filterAllActivity: formatMessage({
      id: "VSX.ActivityStream.filterAllActivity",
      defaultMessage: "All activity"
    }),
    filterComments: formatMessage({
      id: "VSX.ActivityStream.filterComments",
      defaultMessage: "Comments only"
    }),
    attachmentTitle: formatMessage({
      id: "VSX.ActivityStream.attachmentTitle",
      defaultMessage: "Attach File"
    })
  };
};
exports.createActivityStreamIntl = createActivityStreamIntl;